import { AuthorizationInterceptor } from "@miracledevs/paradigm-web-fetch/interceptors/authorization.interceptor";
import { ContentTypeInterceptor } from "@miracledevs/paradigm-web-fetch/interceptors/content-type.interceptor";
import { HttpClient, QueryString } from "@miracledevs/paradigm-web-fetch/http-client";
import { HttpResponse } from "@miracledevs/paradigm-web-fetch";
import { LoginService } from "../../LoginService";
import { AuthenticationInterceptor } from "../interceptors/AuthenticationInterceptor";

export class ApiClientBase
{
    private readonly httpClient: HttpClient;

    constructor(private readonly baseUrl: string | undefined)
    {
        this.httpClient = new HttpClient();
        this.httpClient.registerInterceptor(new ContentTypeInterceptor('application/json'));
    }

    authorize(token: string, loginService: LoginService): void
    {
        this.httpClient.registerInterceptor(new AuthorizationInterceptor(token, 'equipcast-auth'));
        this.httpClient.registerInterceptor(new AuthenticationInterceptor(loginService));
    }

    async get<TResult>(url: string, queryString?: QueryString): Promise<TResult>
    {
        return this.processResponse<TResult>(await this.httpClient.get(`${this.baseUrl}/${url}`, queryString));
    }

    async post<TResult>(url: string, queryString?: QueryString, body?: BodyInit): Promise<TResult>
    {
        return this.processResponse<TResult>(await this.httpClient.post(`${this.baseUrl}/${url}`, queryString, body));
    }

    async put<TResult>(url: string, queryString?: QueryString, body?: BodyInit): Promise<TResult>
    {
        return this.processResponse<TResult>(await this.httpClient.put(`${this.baseUrl}/${url}`, queryString, body));
    }

    async patch<TResult>(url: string, queryString?: QueryString, body?: BodyInit): Promise<TResult>
    {
        return this.processResponse<TResult>(await this.httpClient.patch(`${this.baseUrl}/${url}`, queryString, body));
    }

    async delete<TResult>(url: string, queryString?: QueryString): Promise<TResult>
    {
        return this.processResponse<TResult>(await this.httpClient.delete(`${this.baseUrl}/${url}`, queryString));
    }

    private async processResponse<TResult>(response: HttpResponse): Promise<TResult>
    {
        const result = await response.json();

        if (!response.ok)
        {
            if (result && result.hasOwnProperty("message"))
            {
                throw new Error(result.message);
            }

            throw new Error(`The service responded with ${response.status} '${response.statusText}'`);
        }

        return result as TResult;
    }
}